import {CARD_LOGOS} from '../consts';

export const getZepzCardLogoUrl = card => {
    const cardType = card?.scheme.toLowerCase();

    /* TODO: TBD default value */
    return CARD_LOGOS[cardType] || CARD_LOGOS.cybersourceOther;
};
